<mat-dialog-content aria-modal="true" class="d-flex flex-col" role="dialog">
    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0">{{ this.title || 'Select Users' }}</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (keyup.enter)="this.dialogRef.close();" class="mat-dialog-close" mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <form class="pt-10">
        <mat-form-field appearance="outline" class="whiteField w-100 z-index-less"
                        color="primary">
            <mat-label>Select User</mat-label>
            <input [formControl]="userSearchControl"
                   [matAutocomplete]="auto"
                   matInput placeholder="Select User" cdkFocusInitial>
            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="selectUser($event.option.value)">
                @for (user of filteredUsers; track user) {
                    <mat-option [value]="user">
                        {{ user.username }}
                    </mat-option>
                }

            </mat-autocomplete>
            @if (loadingUsers) {
                <mat-icon matSuffix>
                    <mat-spinner color="primary"></mat-spinner>
                </mat-icon>
            }
        </mat-form-field>
        @if (selectedUser) {
            <mat-chip-set>
                <mat-chip (removed)="this.selectedUser = undefined"
                          class="smChip">
                    {{ selectedUser.username }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-set>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex-space-around">
    <button (keyup.enter)="this.dialogRef.close();" color="warn" mat-dialog-close
            mat-raised-button>
        Cancel
    </button>
    @if (this.selectedUser) {
        <button (click)="this.dialogRef.close(this.selectedUser);"
                [disabled]="loadingUsers"
                color="primary" mat-raised-button>
            Save
            @if (loadingUsers) {
                <mat-icon matSuffix>
                    <mat-spinner color="primary"></mat-spinner>
                </mat-icon>
            }
        </button>
    }
</mat-dialog-actions>

